import React from 'react';
import { CheckIcon, GiftIcon, PartyPopperIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-white px-5 pb-16 pt-4 sm:pb-20" aria-label="Exclusive bonuses" data-id="element-117" data-mp="1cj3egv5fg1ez">
      <div className="mx-auto max-w-6xl" data-id="element-118" data-mp="18lfgtkccnuje">
        <div className="rounded-3xl bg-alert px-5 py-8 text-center text-white sm:py-10" data-id="element-119" data-mp="259letoernoop">
          <p className="font-display text-base font-extrabold uppercase text-white/90" data-id="element-120" data-mp="20aqvmlcvzy42">But that’s not all…</p>
          <h2 className="mt-2 font-display text-[28px] font-black uppercase leading-[1.05] sm:text-4xl lg:text-5xl" data-id="element-121" data-mp="1w8x3x2ko64g1">
            You’ll also receive 5 exclusive clinical bonuses!
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-white/90" data-id="element-122" data-mp="ktqjtqol2hw4">
            Five complementary resources to help you explore important areas of maxillary growth and orthopedic
            assessment in greater detail.
          </p>
        </div>

        <div className="mt-6 space-y-14 sm:mt-12 sm:space-y-20" data-id="element-123" data-mp="1euga6mykqwud">
          {bonuses.map((bonus, i) => <article key={bonus.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-124" data-mp="1jryiqc8oja1u" data-mpi={i}>
              <div className={`-mx-5 sm:mx-0 ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-125" data-mp="15v2zjqyps282">
                <img src={bonus.image} alt={`Bonus #${bonus.number}: ${bonus.title}`} className="mx-auto block w-full max-w-none md:max-w-lg" loading="lazy" data-id="element-126" data-mp="1aqiaob5c7k0s" />
              </div>
              <div data-id="element-127" data-mp="n3a6xxnk4j0v">
                <div className="flex flex-wrap items-center gap-3" data-id="element-128" data-mp="n3s898p2tnfn">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-alert px-3.5 py-1.5 font-display text-sm font-black uppercase text-white" data-id="element-129" data-mp="r3kng48z6rtz">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-130" data-mp="d6e4o9o94t4r" />
                    Bonus #{bonus.number}
                  </span>
                  <span className="text-sm font-semibold text-ink/60" data-id="element-131" data-mp="2jt3gg6qumk04">
                    Reference value: <s className="text-alert" data-id="element-132" data-mp="2f23h6uu9bpug">${bonus.value}</s>{' '}
                    <strong className="text-success" data-id="element-133" data-mp="2ezqte11til9h">Included</strong>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-[26px] font-black uppercase leading-tight text-navy-950 sm:text-3xl" data-id="element-134" data-mp="2615d6cjtjibv">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-ink/75" data-id="element-135" data-mp="32qmop85hfylh">{bonus.description}</p>
                <p className="mt-5 font-display text-sm font-extrabold uppercase text-navy-900" data-id="element-136" data-mp="2yqlyyrcxo0z4">Inside:</p>
                <ul className="mt-2.5 space-y-2.5" data-id="element-137" data-mp="2tsu902vumoxk">
                  {bonus.topics.map(topic => <li key={topic} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-138" data-mp="2ou0vwbkh4zxx">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="1i9hvml8g5jm9" />
                      {topic}
                    </li>)}
                </ul>
                <p className="mt-5 border-l-4 border-gold pl-4 text-[15px] font-semibold leading-snug text-navy-950" data-id="element-140" data-mp="187nldlyas7y1">
                  {bonus.closing}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-16 rounded-3xl bg-navy-950 px-6 py-10 text-center text-white" data-id="element-141" data-mp="1hyijpootixzu">
          <PartyPopperIcon className="mx-auto h-10 w-10 text-gold" aria-hidden="true" data-id="element-142" data-mp="1lzu156xjgcwy" />
          <h3 className="mt-3 font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-143" data-mp="1qxm36trwdfev">
            All 5 bonuses are included with your order!
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-base text-white/80" data-id="element-144" data-mp="1vvdvvq0d95k4">
            You won’t need to purchase these five resources separately as part of this offer.
          </p>
          <div className="mt-8" data-id="element-145" data-mp="1l1sr4xnameh">
            <CtaButton label="Yes! Add all 5 bonuses to my order" data-id="element-146" data-mp="6i0mhmdecrc5" />
          </div>
        </div>
      </div>
    </section>;
}